import react from "react";

import Lozza1 from "../images/commercials/Lozza/LOZZAOCCHIALI_001 Large.jpeg";
import Lozza2 from "../images/commercials/Lozza/LOZZAOCCHIALI_002 Large.jpeg";
import Lozza3 from "../images/commercials/Lozza/LOZZAOCCHIALI_003 Large.jpeg";
import Lozza4 from "../images/commercials/Lozza/LOZZAOCCHIALI_004 Large.jpeg";
import Lozza5 from "../images/commercials/Lozza/LOZZAOCCHIALI_005 Large.jpeg";
import Lozza6 from "../images/commercials/Lozza/LOZZAOCCHIALI_006 Large.jpeg";
import Lozza7 from "../images/commercials/Lozza/LOZZAOCCHIALI_007 Large.jpeg";
import Lozza8 from "../images/commercials/Lozza/LOZZAOCCHIALI_008 Large.jpeg";
import Lozza9 from "../images/commercials/Lozza/LOZZAOCCHIALI_009 Large.jpeg";

const Lozza = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Lozza1} alt="Lozza Occhiali - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza2} alt="Lozza Occhiali - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza3} alt="Lozza Occhiali - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza4} alt="Lozza Occhiali - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza5} alt="Lozza Occhiali - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza6} alt="Lozza Occhiali - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza7} alt="Lozza Occhiali - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza8} alt="Lozza Occhiali - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={Lozza9} alt="Lozza Occhiali - Image 9"/>
                </div>
            </div>
        </div>
    );
}

export default Lozza;